var base = base || {};


// Enable responsive youtube video
//-----------------------------------------------------------------
base.responsiveVideo = function() {
    var $parentEl = $('.wysiwyg');

    if (!$parentEl.length) {
        return;
    }

    var $allVideos = $('iframe').filter(function(){return this.src.match(/(youtube\.com|youtu\.be)/i);});

    $allVideos.each(function() {
        var _aspectRatio = this.height / this.width * 100;

        $(this).wrap('<div class="video-container"></div>');
        $(this).parent().css('padding-bottom', _aspectRatio+'%');
    });
};


// Enable "sticky" sidebar
//-----------------------------------------------------------------
base.stickyFill = function() {
    var stickyElements = document.getElementsByClassName('sticky');

    for (var i = stickyElements.length - 1; i >= 0; i--) {
        Stickyfill.add(stickyElements[i]);
    }
};



$(document).ready(function (){
    base.responsiveVideo();
    // base.stickyFill();

});